import React, { useState, useEffect } from 'react';
import Header from '../../../common/components/Header/Header';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-light-svg-icons';
import { getIndividualPerformanceReport } from '../../../common/constants/api';
import IndividualPerformanceTable from './IndividualPerformanceTable/IndividualPerformanceTable';
import moment from 'moment';
import * as _ from 'lodash';
import CommonYearPicker from '../../../common/components/CommonYearPicker/CommonYearPicker';
import { navigate } from 'gatsby';
import backBtn_icon from '../../../images/icons/backBtn_icon.svg';

const IndividualPerformance = () => {
  const [tableData, setTableData] = useState([]);
  const [tableInfo, setTableInfo] = useState({ size: 50 });
  const [tableLoading, setTableLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [rmId, setRmId] = useState('');
  const [filteredProduct, setFilteredProduct] = useState('');
  const [userId, setUserId] = useState(
    window?.location?.search
      ? new URLSearchParams(window?.location?.search)?.get('user')
      : ''
  );

  const [years, setYears] = useState({
    value: '',
    label: 'Choose Years'
  });

  const getPerformanceReport = () => {
    if (!userId) navigate('/app/report/teamperformance');
    setTableLoading(true);
    getIndividualPerformanceReport(userId, years?.value || moment().year())
      .then(res => {
        setTableLoading(false);
        setTableData(res || []);
        setTableInfo(res?.page);
      })
      .catch(err => {
        setTableData([]);
        setTableLoading(false);
      });
  };
  useEffect(() => {
    getPerformanceReport();
  }, [years?.value]);

  return (
    <React.Fragment>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-hidden font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />

          <div className="widhtMd max-screen flex-1  w-full ">
            <div className="flex">
              <div className="flex items-center  flex-col xl:flex-row w-full">
                <div className="w-full text-black-400 text-md ml-4 font-bold mt-4 relative">
                  <span className="mr-1 cursor-pointer">Reports</span>
                  <FontAwesomeIcon
                    icon={faAngleDoubleRight}
                    className="mr-1 mt-1"
                  />
                  <span className="text-black-400">Individual Performance</span>
                  <FontAwesomeIcon
                    icon={faAngleDoubleRight}
                    className="ml-1 mr-1 mt-1"
                  />
                  <span className="capitalize text-green-800">{`${tableData?.[0]
                    ?.empName?.firstName || ''} ${tableData?.[0]?.empName
                    ?.middleName || ''} ${tableData?.[0]?.empName?.lastName ||
                    ''}`}</span>
                </div>
              </div>
              <Header />
            </div>
            <div
              className="ml-4 mt-4 md:mt-0 cursor-pointer mb-5"
              onClick={() => {
                navigate('/app/report/teamperformance');
              }}
            >
              <img src={backBtn_icon} alt="" />
            </div>

            <div className="w-full">
              <div className="px-5 py-2">
                <CommonYearPicker
                  baseYear={moment().format('YYYY') - 20}
                  addYears={20}
                  years={years}
                  setYears={setYears}
                  selectBaseYear={true}
                />
              </div>
              <IndividualPerformanceTable
                tableData={tableData}
                tableInfo={tableInfo}
                tableLoading={tableLoading}
                setPage={setPage}
                setPageSize={setPageSize}
                rm={rmId}
                setRmId={setRmId}
                setFilteredProduct={setFilteredProduct}
                filteredProduct={filteredProduct}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default IndividualPerformance;
